/** Canonical DB names — use original_name for sort, not localized name. */
const INCOME_CATEGORY_PRIORITY = [
	'Salary',
	'Freelance',
	'Business',
	'Investment',
	'Rental',
	'Other',
];

const PRIORITY_RANK = new Map(
	INCOME_CATEGORY_PRIORITY.map((name, index) => [name, index]),
);

const getSortKey = category => String(category.original_name || category.name);

const getRank = sortKey =>
	PRIORITY_RANK.get(sortKey) ?? INCOME_CATEGORY_PRIORITY.length;

export function sortIncomeCategories(categories) {
	if (!Array.isArray(categories)) return [];
	return [...categories].sort((a, b) => {
		const aKey = getSortKey(a);
		const bKey = getSortKey(b);
		return getRank(aKey) - getRank(bKey) || aKey.localeCompare(bKey);
	});
}
